export default __webpack_public_path__ + "static/retail-brands.url-e3b06d08165c0dfe2d3902a07a9bf0c2.svg";